import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html',
    imports: [DatePipe]
})

export class FooterComponent{
    test : Date = new Date();
}
